export default __webpack_public_path__ + "static/media/photo--sm--127.f391b863.jpg";